import { connect } from 'react-redux'
import Component from './component'
import Dev from '../dev'
import KeepAlive from './keepAlive'
import IntroVideo from './introVideo'
import config from 'config'
import FPSmeter from '../dev/fpsMeter'
import GUIComponent from '../dev/disGUI'
import RecordingControls from '../dev/recordingControls'
import Watermark from './watermark'
import PopupTriggerer from '../dev/popupTriggerer'
import React from 'react'

/**
 * This is the layout for the application.
 * It will display the preloader, then the game and
 * any additional tools chosen (e.g. developer tools).
 */
@connect(state => ({
  session: state.session,
  hideLoader: state.base.hideLoader,
  loading: state.base.loading,
  assetProgress: state.base.assetProgress,
  hideSplash: state.base.hideSplash,
  hasIntro: state.base.hasIntro,
  hideIntro: state.base.hideIntro,
  showRecordingControls: state.base.showRecordingControls,
  showConfigurableVariables: state.base.showConfigurableVariables,
  showPopupTriggerer: state.base.showPopupTriggerer,
}))
export default class UI extends Component {
  render() {
    const { session, Game, LoadingScreen, hideLoader, SplashScreen, IntroMovie, hasIntro,
      Components, loading, assetProgress = {}, hideSplash, hideIntro, showRecordingControls,
      ConfigurableVariables, showConfigurableVariables,
      showPopupTriggerer,
    } = this.props
    const { loadedLocale } = session
    const preLoaderCls = !loading ? 'done' : ''

    const components = []

    Object.keys(Components).forEach(c => {
      const comp = Components[c]
      const Temp = comp.Component

      if (Temp) {
        components.push(<Temp key={c} {...(comp.props || {})} />)
      }
    })

    let progress = 0

    const keys = Object.keys(assetProgress)
    keys.forEach(key => {
      progress += (assetProgress[key] / keys.length)
    })

    let dev
    if (session.developerMode) {
      const portrait = window.innerHeight > window.innerWidth
      const hasConfigurableVariables = !!ConfigurableVariables
      dev = <Dev {...{ Components, portrait, hasConfigurableVariables }} />
    }

    return (
      <div className={loadedLocale}>
        { loadedLocale && !hideIntro && hasIntro && <IntroVideo IntroMovie={IntroMovie} /> }

        { !config.AUTOSLEEP_DISABLED && <KeepAlive /> }
        { !hideLoader ? (
          <div style={{ zIndex: 1003 }} id="preLoaderWrapper" className={preLoaderCls} key="preLoader">
            <div id="background" />
            <div id="preLoader">
              { LoadingScreen || <div /> }
              <div className="loading">Loading...</div>
              <div className="loadingBar">
                <div id="progressBarValue" style={{ width: `${progress}%` }} />
              </div>
            </div>
          </div>
        )
        :
          <div key="preLoader" />
        }

        { (hideIntro || !hasIntro) && !loading ? (
          <div key="game">
            <Game />
            { components }
            {dev}
          </div>
          ) : <div key="game" />
        }

        { !loading && !hideSplash && SplashScreen && <SplashScreen /> }

        { session.developerMode && (
          <React.Fragment>
            <FPSmeter />
            { showConfigurableVariables && <GUIComponent {...{ ConfigurableVariables }} /> }
            { showRecordingControls && <RecordingControls />}
            { showPopupTriggerer && <PopupTriggerer />}
          </React.Fragment>
        )}

        { config.FEATURE_CONFIG.WATERMARK && <Watermark /> }
      </div>
    )
  }
}
